import axios from '../utils/axios';

export default function updateClientEngagementStatus(adminId,data) {
    return (
        axios.post('/admin/' + adminId +'/update-client-status',  data )
    )
}